import common from './common';
import navigate from './navigate';
import error from './error';

export default {
  common,
  navigate,
  error,
};